import { render } from "./MobileBottomPromo.vue?vue&type=template&id=78b0fcab&scoped=true"
import script from "./MobileBottomPromo.vue?vue&type=script&lang=js"
export * from "./MobileBottomPromo.vue?vue&type=script&lang=js"

import "./MobileBottomPromo.vue?vue&type=style&index=0&id=78b0fcab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b0fcab"]])

export default __exports__